import {configureStore, ThunkAction, Action} from '@reduxjs/toolkit';
import counterReducer from './slice/counterSlice';
import accountReducer from './slice/accountSlice';
import propertyReducer from './slice/propertySlice';
import devicesReducer from './slice/deviceSlice';
import propertyCacheReducer from './slice/propertyCacheSlice';
import residentReducer from './slice/residentSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    account: accountReducer,
    property: propertyReducer,
    device: devicesReducer,
    propertyCache: propertyCacheReducer,
    resident: residentReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        ignoredPaths: ['account.userDetail.headers'],
      },
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
